import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static identifier = "bonus-timer"
    static values = {
        expiration: String
    }

    static targets = ["countdown"]

    connect() {
        this.update()
        this.timer = setInterval(() => this.update(), 1000)
    }

    disconnect() {
        clearInterval(this.timer)
    }

    update() {
        if (!this.hasCountdownTarget) return
        const expiresAt = new Date(this.expirationValue)
        const now = new Date()
        const secondsRemaining = Math.floor((expiresAt - now) / 1000)

        if (secondsRemaining <= 0) {
            this.countdownTarget.textContent = "(Expired)"
            clearInterval(this.timer)
            return
        }

        const minutes = Math.floor(secondsRemaining / 60)
        const seconds = secondsRemaining % 60
        this.countdownTarget.textContent = `(${minutes}:${seconds.toString().padStart(2, "0")})`
    }
}
